var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ResourceTable',{attrs:{"schema":_vm.schema,"rows":_vm.filterHideRows,"loading":_vm.loading,"use-query-params-for-simple-filtering":_vm.useQueryParamsForSimpleFiltering,"data-testid":"app-cluster-repo-list"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }